import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DEMO_STORAGE_KEY = '@Samasc:quality-control-demo';

/**
 * Modo demo é DESLIGADO por padrão — o módulo usa a API real. Só liga com
 * `?demo=1` na URL e, a partir daí, fica lembrado em sessionStorage (só
 * nesta aba) para sobreviver à navegação pela Sidebar, cujos links são
 * estáticos e não carregam a querystring. `?demo=0` desliga. Fechar a aba
 * também desliga.
 *
 * Versões anteriores gravavam em localStorage (ligado para sempre); a
 * chave antiga é apagada para ninguém ficar preso no modo demo.
 */
export function useDemoMode(): boolean {
  const location = useLocation();
  const queryDemo = new URLSearchParams(location.search).get('demo');

  useEffect(() => {
    try {
      window.localStorage.removeItem(DEMO_STORAGE_KEY);
      if (queryDemo === '1') {
        window.sessionStorage.setItem(DEMO_STORAGE_KEY, '1');
      } else if (queryDemo === '0') {
        window.sessionStorage.removeItem(DEMO_STORAGE_KEY);
      }
    } catch {
      // Storage indisponível (modo privado/bloqueado): vale só a querystring.
    }
  }, [queryDemo]);

  if (queryDemo === '1') return true;
  if (queryDemo === '0') return false;
  try {
    return window.sessionStorage.getItem(DEMO_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}
